import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WithAuthComponent } from '@app/auth/container/with-auth/with-auth.component';

const SubAppRoutes = [
  {
    load: true,
    path: 'agent',
    component: WithAuthComponent,
    loadChildren: () => import('../../projects/agent/src/app/features/agent.module').then((r) => r.AgentModule),
    data: {
      breadcrumb: 'Agent',
      permissions: {
        only: 'Agent',
        redirectTo: '/page-not-found',
      },
    },
  },
  {
    load: true,
    path: 'composer',
    component: WithAuthComponent,
    loadChildren: () => import('../../projects/admin/src/app/features/admin.module').then((r) => r.AdminModule),
    data: {
      breadcrumb: 'Composer',
      title: 'Composer',
      permissions: {
        only: 'Composer',
        redirectTo: '/page-not-found',
      },
    },
  },
  {
    load: true,
    path: 'supervisor',
    component: WithAuthComponent,
    loadChildren: () =>
      import('../../projects/supervisor/src/app/features/supervisor.module').then((r) => r.SupervisorModule),
    data: {
      breadcrumb: 'Supervisor',
      permissions: {
        // TODO: change access to supervisor
        // Temporary change as no user for sup now.
        only: 'Agent',
        redirectTo: '/page-not-found',
      },
    },
  },
  {
    load: true,
    path: 'QA',
    component: WithAuthComponent,
    loadChildren: () => import('../../projects/QA/src/app/features/QA.module').then((r) => r.QAModule),
    data: {
      breadcrumb: 'QA',
      permissions: {
        // TODO: change access to QA
        // Temporary change as no user for QA now.
        only: 'QA',
        redirectTo: '/page-not-found',
      },
    },
  },
  {
    load: true,
    path: 'admin',
    component: WithAuthComponent,
    loadChildren: () => import('../../projects/admin/src/app/features/admin.module').then((r) => r.AdminModule),
    data: {
      breadcrumb: 'Admin',
      permissions: {
        only: 'admin',
        redirectTo: '/page-not-found',
      },
    },
  },
];

const routes: Routes = [{ path: '**', redirectTo: '/page-not-found', pathMatch: 'full' }];

SubAppRoutes.forEach((subRoute) => {
  if (subRoute.load) {
    routes.unshift(subRoute);
  }
});

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  // imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
